// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   Audit Findings — Main Page Styles
   ============================================= */

:root {
  --af-primary: #0d6efd;
  --af-danger: #dc3545;
  --af-warning: #fd7e14;
  --af-success: #198754;
  --af-muted: #6c757d;
  --af-border: #dee2e6;
  --af-bg-light: #f8f9fa;
  --af-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  --af-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.12);
  --af-radius: 6px;
  --af-transition: 0.2s ease;
}

/* =============================================
   Container
   ============================================= */
.audit-findings-container {
  padding: 1.5rem 1.25rem;
  background-color: var(--af-bg-light);
  min-height: 100vh;
}

/* =============================================
   Alerts
   ============================================= */
.findings-alert {
  border-left: 4px solid transparent;
  animation: slideInDown 0.25s ease;
}

.findings-alert.alert-success {
  border-left-color: var(--af-success);
}

.findings-alert.alert-danger {
  border-left-color: var(--af-danger);
}

@keyframes slideInDown {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* =============================================
   Page Header Card
   ============================================= */
.findings-header-card {
  border: none;
  border-radius: var(--af-radius);
  box-shadow: var(--af-shadow);
  background: white;
}

.findings-page-title {
  font-weight: 700;
  color: #1a2535;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
}

/* =============================================
   Tab Card
   ============================================= */
.findings-tabs {
  border: none;
  border-radius: var(--af-radius);
  box-shadow: var(--af-shadow);
  overflow: visible;
}

.findings-tabs .card-header {
  background: white;
  border-bottom: 1px solid var(--af-border);
  border-radius: var(--af-radius) var(--af-radius) 0 0;
}

.findings-tabs .nav-tabs {
  border-bottom: none;
}

.findings-tabs .nav-tabs .nav-link {
  color: var(--af-muted);
  border: none;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 0.6rem 0.9rem;
  transition: color var(--af-transition), border-color var(--af-transition);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.findings-tabs .nav-tabs .nav-link.active {
  color: var(--af-primary);
  border-bottom-color: var(--af-primary);
  background: transparent;
  font-weight: 600;
}

.findings-tabs .nav-tabs .nav-link:hover:not(.active) {
  color: var(--af-primary);
  border-bottom-color: rgba(13, 110, 253, 0.3);
}

.tab-content-body {
  padding: 1.25rem;
  background: white;
  border-radius: 0 0 var(--af-radius) var(--af-radius);
}

/* =============================================
   Filter Panel
   ============================================= */
.findings-filter-card {
  border: 1px solid var(--af-border);
  border-radius: var(--af-radius);
  box-shadow: none;
  background: #fefefe;
}

.findings-filter-card .card-body {
  padding: 0.65rem 0.9rem;
}

/* =============================================
   Findings Table
   ============================================= */
.findings-list {
  border: 1px solid var(--af-border);
  border-radius: var(--af-radius);
  overflow: hidden;
}

.findings-list .table {
  margin-bottom: 0;
}

.findings-list thead th {
  background-color: #f4f6f9;
  border-top: none;
  border-bottom: 2px solid var(--af-border);
  font-weight: 600;
  font-size: 0.82rem;
  color: #495057;
  padding: 0.75rem 1rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.findings-list tbody td {
  padding: 0.75rem 1rem;
  font-size: 0.92rem;
  border-bottom: 1px solid #f0f2f5;
  vertical-align: middle;
}

.finding-row {
  transition: background-color var(--af-transition);
}

.finding-row:hover {
  background-color: #f0f7ff !important;
}

.finding-requirement {
  color: #333;
  line-height: 1.4;
}

/* =============================================
   Severity Badges (Bootstrap override)
   ============================================= */
.badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

/* =============================================
   Status Badge (legacy — kept for detail modal)
   ============================================= */
.status-badge {
  display: inline-block;
  padding: 0.3em 0.7em;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.status-badge.open {
  background-color: #fee2e2;
  color: #991b1b;
}

.status-badge.in-progress {
  background-color: #fef3c7;
  color: #92400e;
}

.status-badge.resolved {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge.closed {
  background-color: #e5e7eb;
  color: #374151;
}

/* =============================================
   Action Buttons
   ============================================= */
.findings-action-btn {
  width: 30px;
  height: 30px;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  transition: all var(--af-transition);
  border-radius: 5px !important;
}

.findings-action-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* =============================================
   Empty State
   ============================================= */
.empty-state {
  text-align: center;
  padding: 3rem 1.5rem;
  color: var(--af-muted);
}

.empty-state-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f0f4ff;
  border-radius: 50%;
  color: #9db5ff;
}

.empty-state h6 {
  color: #374151;
  font-weight: 600;
}

/* =============================================
   Loading State
   ============================================= */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}

.spinner-icon {
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* =============================================
   Pagination
   ============================================= */
.pagination-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: var(--af-bg-light);
  border: 1px solid var(--af-border);
  border-radius: var(--af-radius);
}

.pagination-info {
  font-size: 0.85rem;
  color: var(--af-muted);
}

.pagination-container .pagination .page-link {
  font-size: 0.85rem;
  padding: 0.3rem 0.6rem;
  color: var(--af-primary);
  border-color: var(--af-border);
  transition: all var(--af-transition);
}

.pagination-container .pagination .page-item.active .page-link {
  background-color: var(--af-primary);
  border-color: var(--af-primary);
}

/* =============================================
   Statistics — Stat Cards
   ============================================= */
.stat-card {
  border-radius: var(--af-radius);
  padding: 1.1rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: var(--af-shadow);
  transition: box-shadow var(--af-transition), transform var(--af-transition);
  position: relative;
  overflow: hidden;
  border: none;
}

.stat-card:hover {
  box-shadow: var(--af-shadow-hover);
  transform: translateY(-2px);
}

.stat-card-body {
  position: relative;
  z-index: 1;
}

.stat-label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.85;
  margin-bottom: 0.35rem;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
}

.stat-icon {
  opacity: 0.18;
  position: relative;
  z-index: 1;
}

/* Primary — Total */
.stat-card-primary {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
}

/* Danger — Critical */
.stat-card-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

/* Warning — Major */
.stat-card-warning {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: white;
}

/* Success — Resolved/Closed */
.stat-card-success {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
}

/* =============================================
   Statistics Distribution Cards
   ============================================= */
.tab-content-body .card {
  border: 1px solid var(--af-border);
  border-radius: var(--af-radius);
  box-shadow: var(--af-shadow);
}

.tab-content-body .card .card-header {
  background: var(--af-bg-light);
  border-bottom: 1px solid var(--af-border);
  padding: 0.75rem 1rem;
}

/* =============================================
   Finding Detail Modal
   ============================================= */
.finding-detail-modal .modal-content {
  border: none;
  border-radius: var(--af-radius);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.finding-detail-header {
  background: #f4f6f9;
  border-bottom: 1px solid var(--af-border);
  padding: 1rem 1.25rem;
}

.finding-detail-section {
  margin-bottom: 1.1rem;
}

.finding-detail-section h6 {
  font-weight: 600;
  color: #1a2535;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 0.4rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #edf0f5;
}

.finding-detail-section p {
  margin: 0;
  color: #4b5563;
  line-height: 1.6;
  word-break: break-word;
  white-space: pre-wrap;
  font-size: 0.92rem;
}

/* =============================================
   Responsiveness
   ============================================= */
@media (max-width: 767px) {
  .audit-findings-container {
    padding: 1rem 0.75rem;
  }

  .tab-content-body {
    padding: 0.9rem;
  }

  .findings-page-title {
    font-size: 1.05rem;
  }

  .findings-list thead th {
    font-size: 0.78rem;
    padding: 0.6rem 0.5rem;
  }

  .findings-list tbody td {
    padding: 0.6rem 0.5rem;
    font-size: 0.85rem;
  }

  .pagination-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .stat-card {
    padding: 0.9rem 1rem;
  }

  .stat-value {
    font-size: 1.6rem;
  }
}

@media (max-width: 575px) {
  .findings-filter-card .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .findings-filter-card .col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .stat-label {
    font-size: 0.72rem;
  }

  .stat-value {
    font-size: 1.4rem;
  }
}

/* =============================================
   Alert & Notifications (legacy class support)
   ============================================= */
.alert-finding {
  border-left: 4px solid transparent;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: var(--af-radius);
}

.alert-finding.success {
  background-color: #d4edda;
  border-left-color: #28a745;
  color: #155724;
}

.alert-finding.error {
  background-color: #f8d7da;
  border-left-color: #dc3545;
  color: #721c24;
}

.alert-finding.warning {
  background-color: #fff3cd;
  border-left-color: #ffc107;
  color: #856404;
}

.alert-finding.info {
  background-color: #d1ecf1;
  border-left-color: #17a2b8;
  color: #0c5460;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditFindings/index.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,0CAA0C;EAC1C,iDAAiD;EACjD,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;kDAEkD;AAClD;EACE,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;;kDAEkD;AAClD;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;kDAEkD;AAClD;EACE,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;kDAEkD;AAClD;EACE,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yEAAyE;EACzE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;;kDAEkD;AAClD;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;kDAEkD;AAClD;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;kDAEkD;AAClD;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;kDAEkD;AAClD;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;kDAEkD;AAClD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;kDAEkD;AAClD;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;;kDAEkD;AAClD;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;;kDAEkD;AAClD;EACE,YAAY;EACZ,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;kDAEkD;AAClD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;kDAEkD;AAClD;EACE,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB","sourcesContent":["/* =============================================\n   Audit Findings — Main Page Styles\n   ============================================= */\n\n:root {\n  --af-primary: #0d6efd;\n  --af-danger: #dc3545;\n  --af-warning: #fd7e14;\n  --af-success: #198754;\n  --af-muted: #6c757d;\n  --af-border: #dee2e6;\n  --af-bg-light: #f8f9fa;\n  --af-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --af-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.12);\n  --af-radius: 6px;\n  --af-transition: 0.2s ease;\n}\n\n/* =============================================\n   Container\n   ============================================= */\n.audit-findings-container {\n  padding: 1.5rem 1.25rem;\n  background-color: var(--af-bg-light);\n  min-height: 100vh;\n}\n\n/* =============================================\n   Alerts\n   ============================================= */\n.findings-alert {\n  border-left: 4px solid transparent;\n  animation: slideInDown 0.25s ease;\n}\n\n.findings-alert.alert-success {\n  border-left-color: var(--af-success);\n}\n\n.findings-alert.alert-danger {\n  border-left-color: var(--af-danger);\n}\n\n@keyframes slideInDown {\n  from { opacity: 0; transform: translateY(-8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* =============================================\n   Page Header Card\n   ============================================= */\n.findings-header-card {\n  border: none;\n  border-radius: var(--af-radius);\n  box-shadow: var(--af-shadow);\n  background: white;\n}\n\n.findings-page-title {\n  font-weight: 700;\n  color: #1a2535;\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n}\n\n/* =============================================\n   Tab Card\n   ============================================= */\n.findings-tabs {\n  border: none;\n  border-radius: var(--af-radius);\n  box-shadow: var(--af-shadow);\n  overflow: visible;\n}\n\n.findings-tabs .card-header {\n  background: white;\n  border-bottom: 1px solid var(--af-border);\n  border-radius: var(--af-radius) var(--af-radius) 0 0;\n}\n\n.findings-tabs .nav-tabs {\n  border-bottom: none;\n}\n\n.findings-tabs .nav-tabs .nav-link {\n  color: var(--af-muted);\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-weight: 500;\n  font-size: 0.9rem;\n  padding: 0.6rem 0.9rem;\n  transition: color var(--af-transition), border-color var(--af-transition);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.findings-tabs .nav-tabs .nav-link.active {\n  color: var(--af-primary);\n  border-bottom-color: var(--af-primary);\n  background: transparent;\n  font-weight: 600;\n}\n\n.findings-tabs .nav-tabs .nav-link:hover:not(.active) {\n  color: var(--af-primary);\n  border-bottom-color: rgba(13, 110, 253, 0.3);\n}\n\n.tab-content-body {\n  padding: 1.25rem;\n  background: white;\n  border-radius: 0 0 var(--af-radius) var(--af-radius);\n}\n\n/* =============================================\n   Filter Panel\n   ============================================= */\n.findings-filter-card {\n  border: 1px solid var(--af-border);\n  border-radius: var(--af-radius);\n  box-shadow: none;\n  background: #fefefe;\n}\n\n.findings-filter-card .card-body {\n  padding: 0.65rem 0.9rem;\n}\n\n/* =============================================\n   Findings Table\n   ============================================= */\n.findings-list {\n  border: 1px solid var(--af-border);\n  border-radius: var(--af-radius);\n  overflow: hidden;\n}\n\n.findings-list .table {\n  margin-bottom: 0;\n}\n\n.findings-list thead th {\n  background-color: #f4f6f9;\n  border-top: none;\n  border-bottom: 2px solid var(--af-border);\n  font-weight: 600;\n  font-size: 0.82rem;\n  color: #495057;\n  padding: 0.75rem 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  white-space: nowrap;\n}\n\n.findings-list tbody td {\n  padding: 0.75rem 1rem;\n  font-size: 0.92rem;\n  border-bottom: 1px solid #f0f2f5;\n  vertical-align: middle;\n}\n\n.finding-row {\n  transition: background-color var(--af-transition);\n}\n\n.finding-row:hover {\n  background-color: #f0f7ff !important;\n}\n\n.finding-requirement {\n  color: #333;\n  line-height: 1.4;\n}\n\n/* =============================================\n   Severity Badges (Bootstrap override)\n   ============================================= */\n.badge {\n  font-size: 0.75rem;\n  padding: 0.35em 0.65em;\n  border-radius: 4px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n/* =============================================\n   Status Badge (legacy — kept for detail modal)\n   ============================================= */\n.status-badge {\n  display: inline-block;\n  padding: 0.3em 0.7em;\n  border-radius: 20px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n}\n\n.status-badge.open {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.status-badge.in-progress {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.resolved {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.closed {\n  background-color: #e5e7eb;\n  color: #374151;\n}\n\n/* =============================================\n   Action Buttons\n   ============================================= */\n.findings-action-btn {\n  width: 30px;\n  height: 30px;\n  padding: 0 !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--af-transition);\n  border-radius: 5px !important;\n}\n\n.findings-action-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n/* =============================================\n   Empty State\n   ============================================= */\n.empty-state {\n  text-align: center;\n  padding: 3rem 1.5rem;\n  color: var(--af-muted);\n}\n\n.empty-state-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  background: #f0f4ff;\n  border-radius: 50%;\n  color: #9db5ff;\n}\n\n.empty-state h6 {\n  color: #374151;\n  font-weight: 600;\n}\n\n/* =============================================\n   Loading State\n   ============================================= */\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3rem;\n}\n\n.spinner-icon {\n  animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* =============================================\n   Pagination\n   ============================================= */\n.pagination-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  background-color: var(--af-bg-light);\n  border: 1px solid var(--af-border);\n  border-radius: var(--af-radius);\n}\n\n.pagination-info {\n  font-size: 0.85rem;\n  color: var(--af-muted);\n}\n\n.pagination-container .pagination .page-link {\n  font-size: 0.85rem;\n  padding: 0.3rem 0.6rem;\n  color: var(--af-primary);\n  border-color: var(--af-border);\n  transition: all var(--af-transition);\n}\n\n.pagination-container .pagination .page-item.active .page-link {\n  background-color: var(--af-primary);\n  border-color: var(--af-primary);\n}\n\n/* =============================================\n   Statistics — Stat Cards\n   ============================================= */\n.stat-card {\n  border-radius: var(--af-radius);\n  padding: 1.1rem 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: var(--af-shadow);\n  transition: box-shadow var(--af-transition), transform var(--af-transition);\n  position: relative;\n  overflow: hidden;\n  border: none;\n}\n\n.stat-card:hover {\n  box-shadow: var(--af-shadow-hover);\n  transform: translateY(-2px);\n}\n\n.stat-card-body {\n  position: relative;\n  z-index: 1;\n}\n\n.stat-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.85;\n  margin-bottom: 0.35rem;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.stat-icon {\n  opacity: 0.18;\n  position: relative;\n  z-index: 1;\n}\n\n/* Primary — Total */\n.stat-card-primary {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n}\n\n/* Danger — Critical */\n.stat-card-danger {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n}\n\n/* Warning — Major */\n.stat-card-warning {\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\n  color: white;\n}\n\n/* Success — Resolved/Closed */\n.stat-card-success {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  color: white;\n}\n\n/* =============================================\n   Statistics Distribution Cards\n   ============================================= */\n.tab-content-body .card {\n  border: 1px solid var(--af-border);\n  border-radius: var(--af-radius);\n  box-shadow: var(--af-shadow);\n}\n\n.tab-content-body .card .card-header {\n  background: var(--af-bg-light);\n  border-bottom: 1px solid var(--af-border);\n  padding: 0.75rem 1rem;\n}\n\n/* =============================================\n   Finding Detail Modal\n   ============================================= */\n.finding-detail-modal .modal-content {\n  border: none;\n  border-radius: var(--af-radius);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n}\n\n.finding-detail-header {\n  background: #f4f6f9;\n  border-bottom: 1px solid var(--af-border);\n  padding: 1rem 1.25rem;\n}\n\n.finding-detail-section {\n  margin-bottom: 1.1rem;\n}\n\n.finding-detail-section h6 {\n  font-weight: 600;\n  color: #1a2535;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  margin-bottom: 0.4rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid #edf0f5;\n}\n\n.finding-detail-section p {\n  margin: 0;\n  color: #4b5563;\n  line-height: 1.6;\n  word-break: break-word;\n  white-space: pre-wrap;\n  font-size: 0.92rem;\n}\n\n/* =============================================\n   Responsiveness\n   ============================================= */\n@media (max-width: 767px) {\n  .audit-findings-container {\n    padding: 1rem 0.75rem;\n  }\n\n  .tab-content-body {\n    padding: 0.9rem;\n  }\n\n  .findings-page-title {\n    font-size: 1.05rem;\n  }\n\n  .findings-list thead th {\n    font-size: 0.78rem;\n    padding: 0.6rem 0.5rem;\n  }\n\n  .findings-list tbody td {\n    padding: 0.6rem 0.5rem;\n    font-size: 0.85rem;\n  }\n\n  .pagination-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .stat-card {\n    padding: 0.9rem 1rem;\n  }\n\n  .stat-value {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 575px) {\n  .findings-filter-card .col-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .findings-filter-card .col-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .stat-label {\n    font-size: 0.72rem;\n  }\n\n  .stat-value {\n    font-size: 1.4rem;\n  }\n}\n\n/* =============================================\n   Alert & Notifications (legacy class support)\n   ============================================= */\n.alert-finding {\n  border-left: 4px solid transparent;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  border-radius: var(--af-radius);\n}\n\n.alert-finding.success {\n  background-color: #d4edda;\n  border-left-color: #28a745;\n  color: #155724;\n}\n\n.alert-finding.error {\n  background-color: #f8d7da;\n  border-left-color: #dc3545;\n  color: #721c24;\n}\n\n.alert-finding.warning {\n  background-color: #fff3cd;\n  border-left-color: #ffc107;\n  color: #856404;\n}\n\n.alert-finding.info {\n  background-color: #d1ecf1;\n  border-left-color: #17a2b8;\n  color: #0c5460;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
